let configModule;
if (process.env.NODE_ENV === "production") {
  configModule = require("./config.obf.js");
} else {
  configModule = require("./config.js");
}
module.exports = configModule;
